import { PlugZap } from "lucide-react";
import { ErrorState, LoadingState, PageHeader, Pill } from "@/components/common/States";
import { useFetch } from "@/lib/hooks";

function IntegrationCard({ i }) {
  return (
    <div className="panel flex flex-col gap-3 p-5" data-testid={`integration-${i.id}`}>
      <div className="flex items-start justify-between gap-3">
        <p className="font-display text-base font-bold">{i.name}</p>
        <div className="flex flex-col items-end gap-1">
          <Pill value={i.status} testid={`integration-${i.id}-status`}>{i.status === "connected" ? "Connected" : "Not Connected"}</Pill>
          {i.in_use && <Pill tone="teal" testid={`integration-${i.id}-in-use`}>In use · {i.model}</Pill>}
        </div>
      </div>
      <p className="text-sm text-muted-foreground">{i.purpose}</p>
      <dl className="mt-auto grid grid-cols-[90px_1fr] gap-x-3 gap-y-1.5 text-xs">
        <dt className="text-muted-foreground">Access</dt><dd>{i.auth}</dd>
        <dt className="text-muted-foreground">Limits</dt><dd>{i.limits}</dd>
        <dt className="text-muted-foreground">Cost</dt><dd>{i.cost}</dd>
        {i.required_credentials.length > 0 && <><dt className="text-muted-foreground">Credentials</dt><dd className="font-mono text-[11px]">{i.required_credentials.join(", ")}</dd></>}
      </dl>
      <p className="flex items-center gap-1.5 border-t pt-3 text-xs text-muted-foreground"><PlugZap className="h-3.5 w-3.5" />{i.status_reason}</p>
    </div>
  );
}

export default function Integrations() {
  const { data, loading, error, reload } = useFetch("/integrations");
  const groups = data ? [...new Set(data.map((i) => i.category))] : [];
  return (
    <div data-testid="integrations-page">
      <PageHeader eyebrow="Connections" title="Integrations"
        description="Status is computed on the server. A provider only shows Connected when a working connector and valid credentials both exist." />
      {loading && !data && <LoadingState />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {groups.map((g) => (
        <section key={g} className="mb-8">
          <p className="eyebrow mb-3">{g}</p>
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">{data.filter((i) => i.category === g).map((i) => <IntegrationCard key={i.id} i={i} />)}</div>
        </section>
      ))}
    </div>
  );
}
